import { Component, Prop, Vue } from 'vue-property-decorator'
import Chart from 'chart.js/auto'

@Component
export default class LineChart extends Vue {
    @Prop({ default: 0 }) readonly id!: string
    @Prop({ default: [] }) readonly data!: Array<any>
    @Prop({ default: [] }) readonly labels!: Array<string>
    @Prop() readonly title!: string
    @Prop() readonly titleX!: string
    @Prop() readonly titleY!: string

    @Prop() readonly height!: string
    @Prop() readonly width!: string

    myChart: any = null

    mounted() {
        this.createChart({
            datasets: [...this.data],
            labels: this.labels,
        })
    }

    createChart(chartData: object) {
        const canvas = document.getElementById(`linechart-${this.id}`) as HTMLCanvasElement
        const options = {
            type: 'line',
            data: chartData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        onHover: function (e, a) {
                            canvas.style.cursor = 'pointer'
                        },
                        onLeave: function (e, a) {
                            canvas.style.cursor = 'default'
                        },
                        labels: {
                            filter: function (item: any, chart: any) {
                                // filter out duplicated labels
                                return (
                                    chart.datasets.findIndex(
                                        (dataset: any) => dataset.label === item.text
                                    ) === item.datasetIndex
                                )
                            },
                        },
                        title: {
                            text: this.title,
                            display: this.title ? true : false,
                        },
                    },
                },
                scales: {
                    x: {
                        title: {
                            ...(this.titleX && { display: true }),
                            ...(this.titleX && { text: this.titleX }),
                        },
                    },
                    y: {
                        title: {
                            ...(this.titleY && { display: true }),
                            ...(this.titleY && { text: this.titleY }),
                        },
                    },
                },
                onClick: (event, elements, chart) => {
                    this.$emit('elClicked', elements[0]?.datasetIndex, elements[0]?.index)
                },
            },
        }

        // @ts-ignore -- TS type mismatch
        this.myChart = new Chart(canvas, options)
    }

    beforeDestroy() {
        this.myChart?.destroy()
    }
}
